<template>
    <div class="tree-box">
        <div class="drag-tip" v-if="draggable">
            <i class="el-icon-rank"></i> 按住行拖动可调整列顺序
        </div>
        <el-scrollbar class="tree">
            <el-checkbox-group  v-model="checkList" @change="changeCheck">
                <template v-for="item in localCheckBoxList">
                    <div v-if="item.allowCostPrice != 'N'" :key="item.prop || item.id" class="column-row">
                        <span v-if="draggable" class="drag-handle"><i class="el-icon-rank"></i></span>
                        <el-checkbox
                            :label="item.prop"
                            :checked="item.isShow === 'Y'"
                            @change="item.isShow === 'Y'? item.isShow = 'N':item.isShow = 'Y'">
                            {{ item.label }}
                        </el-checkbox>
                    </div>
                </template>
            </el-checkbox-group>
        </el-scrollbar>
        <div class="op-row">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm">确认</el-button>
        </div>
    </div>
  </template>

  <script>
  import Sortable from 'sortablejs'
  export default {
    props: {
        // 可自定义显示隐藏的表头，（接口查询，然后父 传过来）
        checkboxList:Array,
        // 前太写的表头集合
        tableHeaderList:Array,
        // 是否开启拖动排序（默认关闭，不影响其它复用方的原有行为）
        draggable: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        checkList: [],
        // 弹窗本地副本：拖动排序需要可变数组，原 computed 深拷贝无法承载调整后的顺序
        localCheckBoxList: [],
        sortableIns: null
      }
    },
    created() {
        this.localCheckBoxList = JSON.parse(JSON.stringify(this.checkboxList || []))
        this.changeCheck()
    },
    mounted() {
        // 弹窗（父级 v-if）打开后再初始化拖动
        if (this.draggable) {
            this.$nextTick(this.initDrag)
        }
    },
    beforeDestroy() {
        if (this.sortableIns) {
            this.sortableIns.destroy()
            this.sortableIns = null
        }
    },
    methods: {
        // 初始化拖动排序（与系统原有实现 erp-webapp-vuepage/src/components/ysPage/common/customColumn.vue 同款交互）
        initDrag() {
            const wrap = this.$el.querySelector('.el-checkbox-group')
            if (!wrap || this.sortableIns) return
            this.sortableIns = Sortable.create(wrap, {
                animation: 150,
                draggable: '.column-row',
                // 整行可拖（复选框区域除外），兼顾"直接按住行拖动"的操作习惯
                filter: '.el-checkbox',
                preventOnFilter: false,
                onStart: (evt) => {
                    evt.item.classList.add('drag-item')
                },
                onEnd: (evt) => {
                    evt.item.classList.remove('drag-item')
                    const { oldIndex, newIndex } = evt
                    if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) return
                    // 弹窗内 allowCostPrice == 'N' 的行不渲染：把「可见行下标」映射回数组下标
                    const visIdx = this.localCheckBoxList
                        .map((it, i) => (it.allowCostPrice != 'N' ? i : -1))
                        .filter(i => i > -1)
                    const from = visIdx[oldIndex]
                    const to = visIdx[newIndex]
                    if (from === undefined || to === undefined) return
                    const moved = this.localCheckBoxList.splice(from, 1)[0]
                    this.localCheckBoxList.splice(to, 0, moved)
                }
            })
        },
        // 选择
        changeCheck() {
            this.updataHeader()
            // 用户选择过后  把 两个集合 传给父元素，在父元素中提交并且重新赋值表头
            // this.$emit('changeChecked', this.checkboxList, this.tableHeaderList)
        },
        // 当在选择修改显示隐藏时：
        // 把接口查询出来的 可以自定义表头的数据集合 和  前台中写的的表头进行循环对比
        // 如果prop一致说明是同一个列，就把前台写死的（tableHeaderList）更改和自定义选择（checkboxList）的一致  isShow
        updataHeader() {
            this.tableHeaderList.forEach( (item, index) => {
                this.localCheckBoxList.forEach((items, indexs) => {
                    if(item.prop === items.prop) {
                        this.$set(this.tableHeaderList[index], 'isShow', items.isShow)
                    }
                })
            })
        },
        cancel(){
            this.$emit('confirm', {

            })
        },
        confirm(){
            // 以弹窗当前数组顺序提交，sort 与数组下标一致（与系统原有实现同口径）
            const tempCheckBoxList = this.localCheckBoxList.map((item, index) => {
                return Object.assign({}, item, { sort: index })
            })
            this.$emit('confirm', {isSubmit: true,tempCheckBoxList: tempCheckBoxList})
        }
    }
  };
  </script>

  <style scoped lang="less">
    .tree {
        max-height: 300px;
    }
    ::v-deep .el-scrollbar__view {
        max-height: 300px;
    }
    .tree-box{
        margin-top: -20px;
    }
    .op-row{
        text-align: right;
        margin-bottom: -20px;
        margin-top: 8px;
    }
    // 自定义列拖动排序（与系统原有实现样式保持一致）
    .drag-tip {
        font-size: 12px;
        color: #909399;
        padding-bottom: 6px;
        margin-bottom: 6px;
        border-bottom: 1px dashed #ebeef5;
        i {
            color: #409eff;
        }
    }
    .column-row {
        display: flex;
        align-items: center;
        padding: 2px 0;
        border-radius: 4px;
        &:hover {
            background: #f7f9fc;
        }
        &.drag-item {
            background: #eceff5;
        }
    }
    .drag-handle {
        color: #606266;
        cursor: move;
        margin-right: 6px;
        padding: 0 4px;
        font-size: 16px;
        user-select: none;
        &:hover {
            color: #409eff;
        }
    }
  </style>
